export default function () {
  const setupForm = document.getElementById("js-one-time-payment-intent-form")
  const paymentEle = document.getElementById("payment-element")
  if (setupForm && paymentEle) {
    let clientSecret = setupForm.dataset.stripeClientSecret
    const stripe = Stripe(setupForm.dataset.stripePublicKey)
    let elements

    const appearance = {
      theme: "stripe",
      variables: {
        colorPrimary: setupForm.dataset.colorPrimary,
        colorBackground: "#ffffff",
        colorText: "#1c1c1c",
        colorDanger: "#c53030",
        colorIconTabSelected: "#1c1c1c",
        fontFamily: "Graphik Web, Helvetica Neue, Helvetica, Arial, sans-serif",
        spacingUnit: "6px",
        borderRadius: "10px",
        fontSize3Xs: "16px",
      },
      rules: {
        ".Input": {
          border: "solid 1px #858585",
        },
        ".Tab:focus": {
          outline: "solid 3px #1c1c1c",
          border: "none",
          boxShadow: "none",
        },
        ".Input:focus": {
          outline: "solid 3px #1c1c1c",
          border: "none",
          boxShadow: "none",
        },
        ".Tab--selected": {
          color: "#1c1c1c",
          border: "solid 1px var(--colorPrimary)",
          backgroundColor: setupForm.dataset.colorSelected,
        },
      },
    }
    elements = stripe.elements({ appearance, clientSecret })

    const paymentElementOptions = {
      paymentMethodOrder: ["card"],
      layout: "tabs",
      fields: { billingDetails: { name: "auto", email: "auto" } },
    }

    const paymentElement = elements.create("payment", paymentElementOptions)
    paymentElement.mount("#payment-element")

    setupForm.addEventListener("submit", async function (event) {
      event.preventDefault()
      setLoading(true)

      let userFullName = document.getElementById("user-full-name-input").value
      let userEmail = document.getElementById("user-email-input").value

      stripe
        .confirmPayment({
          elements,
          confirmParams: {
            return_url: setupForm.dataset.returnUrl,
            payment_method_data: {
              billing_details: {
                email: userEmail,
                name: userFullName,
              },
            },
          },
        })
        .then(function (result) {
          if (result.error) {
            createErrorNotice(result.error.message)
            setLoading(false)
          }
        })
    })
  }
}

function createErrorNotice(messageText) {
  const messageContainer = document.querySelector("#payment-message")

  messageContainer.classList.remove("hidden")
  messageContainer.textContent = messageText

  setTimeout(function () {
    messageContainer.classList.add("hidden")
    messageContainer.textContent = ""
  }, 4000)
}

function setLoading(isLoading) {
  let button = document.querySelector("#submit")

  if (isLoading) {
    button.disabled = true
    button.innerHTML = `<span class="with-icon gap-2.5 type-button"> Processing... </span>`
  } else {
    button.disabled = false
    button.innerHTML = `<span class="with-icon gap-2.5 type-button"> Pay </span>`
  }
}
